import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './CSS/Home.css';

function Home() {
  return (
    <section id="home" className="home-section">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        interval={4000}
        stopOnHover
        swipeable
        className="home-carousel"
      >
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_1.JPG" alt="Veterinaria 1" className="carousel-image" />
          <div className="carousel-caption">
            <h2>¡BIENVENIDO A AyAVET!</h2>
            <p>Tu mascota, nuestra vocación.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_2.JPG" alt="Veterinaria 2" className="carousel-image" />
          <div className="carousel-caption">
            <h2>ESTAMOS AQUI PARA AYUDARTE</h2>
            <p>Pasión y compromiso. Firmes por nuestra profesión, pacientes y tutores.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_3.JPG" alt="Veterinaria 3" className="carousel-image" />
          <div className="carousel-caption">
            <h2>CUIDADO Y AMOR PARA TU MASCOTA</h2>
            <p>Os acompañamos a lo largo de su vida priorizando su bienestar.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_4.JPG" alt="Veterinaria 4" className="carousel-image" />
          <div className="carousel-caption">
            <h2>ACTUALIZACIÓN CONTINUA</h2>
            <p>Equipos actualizados, formación y profesionalidad a tu disposición.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_5.JPG" alt="Veterinaria 5" className="carousel-image" />
          <div className="carousel-caption">
            <h2>ATENCIÓN PERMANENTE</h2>
            <p>Nuestro esfuerzo, tu tranquilidad.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_6.JPG" alt="Veterinaria 6" className="carousel-image" />
          <div className="carousel-caption">
            <h2>TRATO CERCANO</h2>
            <p>23 años de pasión por nuestra profesión.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_7.JPG" alt="Veterinaria 7" className="carousel-image" />
          <div className="carousel-caption">
            <h2>COMUNICACIÓN</h2>
            <p>Creemos en la importancia de hacer entender a los propietarios nuestro trabajo con sus mascotas.</p>
          </div>
        </div>
        <div className="carousel-slide">
          <img src="/assets/images/ayavet_8.JPG" alt="Veterinaria 8" className="carousel-image" />
          <div className="carousel-caption">
            <h2>CAT FRIENDLY</h2>
            <p>Cuidados y manejo específicos para gatos.</p>
          </div>
        </div>
      </Carousel>
      <div className="home-description">
        <h1>Sobre Nosotros</h1>
        <h3>Tu mascota, nuestra vocación</h3>
        <p>
          Clínica veterinaria de tamaño mediano en el centro de Boadilla del Monte altamente equipada. Contamos con dos consultas, un quirófano, zona de hospitalización, diagnóstico por imagen y una peluquería. Tenemos una gran cantidad de pacientes felinos y realizamos la gran mayoría de protocolos diagnósticos, quirúrgicos y médicos. Nuestro objetivo principal es ofrecer los mejores cuidados posibles para las mascotas, para lo cual nos mantenemos siempre actualizados y damos importancia a la comunicación con los propietarios. Nuestro equipo está formado por dos auxiliares técnicos y entre 2-4 veterinarios con un ambiente laboral excelente.
        </p>
      
        <div className="horario">
          <h2>Horario</h2>
          <ul>
            <li>Lunes a viernes: 11:00 a 20:00 (continuo)</li>
            <li>Sábados: 11:00 a 13:30</li>
            <li>Domingos: Cerrado</li>
          </ul>
        </div>

        <div className="aptitudes">
          <h2>Nuestras Aptitudes</h2>
          <ul>
            <li>Atención personalizada y cercana</li>
            <li>23 años de experiencia cuidando a tus compañeros</li>
            <li>Continua formación de nuestro equipo</li>
            <li>Equipos y tecnología de última generación</li>
            <li>Servicios veterinarios adaptados a cada animal, propietario y situación</li>
            <li>Medicina interna felina</li>
            <li>Medicina interna canina</li>
            <li>Alimentación, peluquería y tienda animal</li>
            <li>Colaboración con distintas colonias y centros de recogida de felinos</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Home;